export const clientVersion = require('../../../package.json').version
